export const oneColumns = [
  {
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' } }, // 提示组件的属性
        [
          h('span', [
            h('span', '课程提供方'), //列名
            h('Icon', { props: { type: 'ios-alert-outline' } }) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '主体分账方为课程的提供方（机构），该分账对象不可删除。'
          ) // 提示内容
        ]
      )
    },
    slot: 'acctName'
  },
  {
    title: '分账方式',
    key: 'acctType'
  },
  {
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' } }, // 提示组件的属性
        [
          h('span', [
            h('span', '分账基数'), //列名
            h('Icon', { props: { type: 'ios-alert-outline' } }) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '默认分账基数，如果分账对象对手续费承担方，实际到账比例会少于设置的分账比例。'
          ) // 提示内容
        ]
      )
    },
    slot: 'proportion'
  },
  // {
  //   title: '平台佣金',
  //   slot: 'platServiceRate'
  // },
  // {
  //   title: '结算方式',
  //   slot: 'accountType'
  // },
  {
    title: '操作',
    slot: 'action',
    width: 220
  }
]

export const twoColumns = [
  {
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' } }, // 提示组件的属性
        [
          h('span', [
            h('span', '分账对象'), //列名
            h('Icon', { props: { type: 'ios-alert-outline' } }) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '主体分账方为课程的提供方（机构），该分账对象不可删除。'
          ) // 提示内容
        ]
      )
    },
    slot: 'acctName'
  },
  {
    title: '分账方式',
    key: 'acctType'
  },
  {
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' } }, // 提示组件的属性
        [
          h('span', [
            h('span', '分账基数'), //列名
            h('Icon', { props: { type: 'ios-alert-outline' } }) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '默认分账基数，如果分账对象对手续费承担方，实际到账比例会少于设置的分账比例。'
          ) // 提示内容
        ]
      )
    },
    slot: 'proportion'
  },
  // {
  //   title: '结算方式',
  //   slot: 'accountType'
  // },
  {
    title: '操作',
    slot: 'action'
  }
]

export const merchantKindList = [
  {
    value: '-1',
    label: '请选择商户身份'
  },
  {
    value: '1',
    label: '平台运营方'
  },
  {
    value: '2',
    label: '渠道代理'
  },
  {
    value: '3',
    label: '校方单位'
  },
  {
    value: '4',
    label: '机构单位'
  },
  {
    value: '5',
    label: '其它'
  },
  {
    value: '6',
    label: '运营方'
  },
  {
    value: '7',
    label: '平台方'
  },
  {
    value: '11',
    label: '机构个人'
  },
  {
    value: '12',
    label: '校方个人'
  },
  {
    value: '13',
    label: '自由从业者'
  }
]
